import { Component, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { Router } from '@angular/router';
import { MarginWrapper } from '../../layouts/margin-wrapper';

@Component({
  selector: 'allas-contactanos',
  imports: [MainLayout, MarginWrapper],
  template: `
    <allas-main-layout>
      <allas-margin-wrapper>
        <!-- Hero Section -->
        <section class="mx-auto my-12 max-w-[60rem] px-6 sm:px-8 fs-condensed">
          <div class="text-center mb-12">
            <h1
              class="text-4xl sm:text-5xl font-bold text-gray-900 mb-4 tracking-wide"
            >
              CONTÁCTANOS
            </h1>
            <p class="text-lg max-w-2xl mx-auto tracking-wide">
              Selecciona una categoría a continuación para enviarnos tus
              preguntas o comentarios
            </p>
          </div>

          <!-- Categories Grid -->
          <div class="grid grid-cols-12 gap-6">
            <!-- Columna Izquierda -->
            <div class="col-span-12 lg:col-span-6 space-y-6">
              <!-- Preguntas sobre Pedidos -->
              <div
                class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-shadow duration-200"
                (click)="navigateToCategory('preguntas-pedidos')"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-4">
                    <div class="w-12 h-12 flex items-center justify-center">
                      <img
                        src="/images/contactanos/box-icon.webp"
                        alt="Preguntas sobre Pedidos"
                        class="w-6 h-6"
                      />
                    </div>
                    <span
                      class="text-xl font-normal text-gray-900 fs-condensed tracking-wide"
                      >PREGUNTAS SOBRE PEDIDOS</span
                    >
                  </div>
                  <svg
                    class="w-5 h-5 text-[#212121]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
              </div>

              <!-- Problemas del Sitio Web -->
              <div
                class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-shadow duration-200"
                (click)="navigateToCategory('problemas-sitio-web')"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-4">
                    <div class="w-12 h-12 flex items-center justify-center">
                      <img
                        src="/images/contactanos/world-warning-icon.webp"
                        alt="Problemas del Sitio Web"
                        class="w-6 h-6"
                      />
                    </div>
                    <span
                      class="text-xl font-normal text-gray-900 fs-condensed tracking-wide"
                      >PROBLEMAS DEL SITIO WEB</span
                    >
                  </div>
                  <svg
                    class="w-5 h-5 text-[#212121]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
              </div>

              <!-- Recompensas -->
              <div
                class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-shadow duration-200"
                (click)="navigateToCategory('recompensas')"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-4">
                    <div class="w-12 h-12 flex items-center justify-center">
                      <img
                        src="/images/contactanos/hand-icon.webp"
                        alt="Recompensas"
                        class="w-6 h-6"
                      />
                    </div>
                    <span
                      class="text-xl font-normal text-gray-900 fs-condensed tracking-wide"
                      >RECOMPENSAS</span
                    >
                  </div>
                  <svg
                    class="w-5 h-5 text-[#212121]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
              </div>

              <!-- Garantía de Productos -->
              <div
                class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-shadow duration-200"
                (click)="navigateToCategory('garantia-productos')"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-4">
                    <div class="w-12 h-12 flex items-center justify-center">
                      <img
                        src="/images/contactanos/verify-check-icon.webp"
                        alt="Garantía de Productos"
                        class="w-6 h-6"
                      />
                    </div>
                    <span
                      class="text-xl font-normal text-gray-900 fs-condensed tracking-wide"
                      >GARANTÍA DE PRODUCTOS</span
                    >
                  </div>
                  <svg
                    class="w-5 h-5 text-[#212121]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>

            <!-- Columna Derecha -->
            <div class="col-span-12 lg:col-span-6 space-y-6">
              <!-- Repuestos y Productos -->
              <div
                class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-shadow duration-200"
                (click)="navigateToCategory('repuestos-productos')"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-4">
                    <div class="w-12 h-12 flex items-center justify-center">
                      <img
                        src="/images/contactanos/shopping-bag-icon.webp"
                        alt="Repuestos y Productos"
                        class="w-6 h-6"
                      />
                    </div>
                    <span
                      class="text-xl font-normal text-gray-900 fs-condensed tracking-wide"
                      >REPUESTOS Y PRODUCTOS</span
                    >
                  </div>
                  <svg
                    class="w-5 h-5 text-[#212121]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
              </div>

              <!-- Experiencia en Tienda -->
              <div
                class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-shadow duration-200"
                (click)="navigateToCategory('experiencia-tienda')"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-4">
                    <div class="w-12 h-12 flex items-center justify-center">
                      <img
                        src="/images/contactanos/shop-store-icon.webp"
                        alt="Experiencia en Tienda"
                        class="w-6 h-6"
                      />
                    </div>
                    <span
                      class="text-xl font-normal text-gray-900 fs-condensed tracking-wide"
                      >EXPERIENCIA EN TIENDA</span
                    >
                  </div>
                  <svg
                    class="w-5 h-5 text-[#212121]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
              </div>

              <!-- Otro Asunto -->
              <div
                class="bg-white rounded-lg shadow-sm border border-gray-200 p-4 cursor-pointer hover:shadow-md transition-shadow duration-200"
                (click)="navigateToCategory('otro-asunto')"
              >
                <div class="flex items-center justify-between">
                  <div class="flex items-center space-x-4">
                    <div class="w-12 h-12 flex items-center justify-center">
                      <img
                        src="/images/contactanos/text-box-icon.webp"
                        alt="Otro Asunto"
                        class="w-6 h-6"
                      />
                    </div>
                    <span
                      class="text-xl font-normal text-gray-900 fs-condensed tracking-wide"
                      >¿OTRO ASUNTO?</span
                    >
                  </div>
                  <svg
                    class="w-5 h-5 text-[#212121]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 5l7 7-7 7"
                    ></path>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <!-- Footer Links -->
          <div class="mt-12 text-center">
            <div
              class="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-4 text-sm text-gray-600"
            >
              <a
                href="/preguntas-frecuentes"
                class="hover:text-blue-500 transition-colors"
              >
                Lee nuestras Preguntas Frecuentes
              </a>
              <span class="hidden sm:inline">|</span>
              <a
                href="/privacidad#trminos-y-condiciones-de-uso"
                class="hover:text-blue-500 transition-colors"
              >
                Nuestros Términos y Condiciones
              </a>
            </div>
          </div>
        </section>
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class Contactanos {
  private titleService = inject(Title);
  private metaService = inject(Meta);

  constructor(private router: Router) {
    this.setMetadata();
  }

  private setMetadata() {
    this.titleService.setTitle('Contáctanos - Allas Repuestos');

    this.metaService.updateTag({
      name: 'description',
      content:
        'Ponte en contacto con Allas Repuestos. Preguntas sobre pedidos, productos, garantías, recompensas y más. Estamos aquí para ayudarte.',
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Contáctanos - Allas Repuestos',
    });

    this.metaService.updateTag({
      property: 'og:description',
      content:
        'Ponte en contacto con Allas Repuestos. Preguntas sobre pedidos, productos, garantías, recompensas y más. Estamos aquí para ayudarte.',
    });

    this.metaService.updateTag({
      property: 'og:type',
      content: 'website',
    });

    this.metaService.updateTag({
      property: 'og:image',
      content: 'https://www.allasrepuestos.com/logos/isotipo.webp',
    });

    this.metaService.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    this.metaService.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });

    this.metaService.updateTag({
      name: 'twitter:title',
      content: 'Contáctanos - Allas Repuestos',
    });

    this.metaService.updateTag({
      name: 'twitter:description',
      content:
        'Ponte en contacto con Allas Repuestos. Preguntas sobre pedidos, productos, garantías, recompensas y más. Estamos aquí para ayudarte.',
    });

    this.metaService.updateTag({
      name: 'keywords',
      content:
        'contacto, servicio al cliente, soporte, ayuda, preguntas, Allas Repuestos, atención al cliente',
    });
  }

  navigateToCategory(category: string) {
    this.router.navigate(['/contactanos', category]);
  }
}
